
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";
// 
// --- Asynchronous Thunks ---

// fetch Project Thunk
export const fetchProjects = createAsyncThunk(
    'Project/fetchProjects',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/project_view`,);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Add Project Thunk
export const AddProject = createAsyncThunk(
    'project/addProject',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/project_add`, values);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add project"
            );
        }
    }
);

// Update Project Thunk
export const UpdateProject = createAsyncThunk(
    'project/updateProject',
    async ({ id, values }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/project_update/${id}`, values);
            return { id, updatedData: response.data?.data || values };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to update project"
            );
        }
    }
);


// Delete Project Thunk (without headers)
export const DeleteProject = createAsyncThunk(
    'project/deleteProject',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/project_delete/${id}`);
            return {
                id,
                message: response.data?.message || "Project deleted successfully",
            };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to delete project"
            );
        }
    }
);

// --- Redux Slice ---
const ProjectSlice = createSlice({
    name: 'project',
    initialState: {

        // Project State
        ProjectData: [],
        projectsLoading: false,
        projectsError: null,

        // New State for Add Project
        AddProjectData: false,
        AddProjectLoading: false,
        AddProjectError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder


            // --- Project Data ---
            .addCase(fetchProjects.pending, (state) => {
                state.projectsLoading = true;
                state.projectsError = null;
            })
            .addCase(fetchProjects.fulfilled, (state, action) => {
                state.projectsLoading = false;
                state.ProjectData = action.payload;
            })
            .addCase(fetchProjects.rejected, (state, action) => {
                state.projectsLoading = false;
                state.projectsError = action.payload;
            })

            // ---- Add Project handler ----
            .addCase(AddProject.pending, (state) => {
                state.AddProjectLoading = true;
                state.AddProjectError = null;
            })
            .addCase(AddProject.fulfilled, (state, action) => {
                state.AddProjectLoading = false;
                state.AddProjectData = true;
                state.ProjectData.push(action.payload); // optional: update state
            })
            .addCase(AddProject.rejected, (state, action) => {
                state.AddProjectLoading = false;
                state.AddProjectError = action.payload;
            })

            // ---- Update Project Handler ----
            .addCase(UpdateProject.pending, (state) => {
                state.projectsLoading = true;
                state.projectsError = null;
            })
            .addCase(UpdateProject.fulfilled, (state, action) => {
                state.projectsLoading = false;
                const index = state.ProjectData.findIndex(p => p._id === action.payload.id);
                if (index !== -1) {
                    state.ProjectData[index] = {
                        ...state.ProjectData[index],
                        ...action.payload.updatedData,
                    };
                }
            })
            .addCase(UpdateProject.rejected, (state, action) => {
                state.projectsLoading = false;
                state.projectsError = action.payload;
            })

            // ---- Delete Project Handler ----
            .addCase(DeleteProject.pending, (state) => {
                state.projectsLoading = true;
                state.projectsError = null;
            })
            .addCase(DeleteProject.fulfilled, (state, action) => {
                state.projectsLoading = false;
                state.ProjectData = state.ProjectData.filter(
                    (project) => project._id !== action.payload.id
                );
            })
            .addCase(DeleteProject.rejected, (state, action) => {
                state.projectsLoading = false;
                state.projectsError = action.payload;
            });
    }
});

// Export the reducer
export default ProjectSlice.reducer;